(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/competition-handler/common/create-competition-model.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/competition-handler/common/create-competition-model.js');
'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
let normalizeCompetition;
let resolveTimeZone;
let constants;
let DrawState;
let logger;
if (svs.isServer) {
  const trinidad = require('trinidad-core').core;
  normalizeCompetition = require('../../competition-helper/assets/javascripts/normalize-competition.es6').normalizeCompetition;
  resolveTimeZone = trinidad.components.require('lb-utils', 'helper-formatdate').api.resolveTimeZone;
  constants = require('./constants.es6');
  DrawState = require('../../../sport/tipsen-shared/assets/javascripts/tipsen-shared.es6').DrawState;
  logger = require('../server/logger');
} else {
  normalizeCompetition = svs.components.marketplaceCompetition.competitionHelper.normalizeCompetition.normalizeCompetition;
  resolveTimeZone = svs.components.lbUtils.helpers.formatDate.resolveTimeZone;
  constants = svs.components.marketplaceCompetition.competitionHandler.common.constants;
  DrawState = svs.components.sport.tipsenShared.DrawState;
  logger = svs.components.marketplaceCompetition.competitionHandler.client.logger;
}
const {
  competitionStates,
  competitionBackendState
} = constants;
const {
  UPCOMING,
  FINISHED,
  REG_OPEN_DRAW_DEFINED,
  REG_CLOSED_DRAW_DEFINED,
  REG_OPEN_DRAW_OPEN,
  REG_CLOSED_DRAW_OPEN,
  REG_OPEN_DRAW_LIVE,
  REG_CLOSED_DRAW_LIVE,
  REG_OPEN_DRAW_FINALIZED,
  REG_CLOSED_DRAW_FINALIZED,
  NO_COMPETITION
} = competitionStates;
const competitionSymbol = Symbol('CompetitionModel');
const isCompetitionModel = instance => (instance === null || instance === void 0 ? void 0 : instance._symbol) === competitionSymbol;

const resolveDrawStatus = (draw, model) => {
  var _competitionData$deta;
  const competitionData = model.getData();
  const currentTime = resolveTimeZone(new Date());
  const isPastRegistration = currentTime > resolveTimeZone(new Date(competitionData.signupStartTime));
  const canRegister = isPastRegistration && draw.getDrawNumber() < model.getFirstDrawNumber();
  const isBeforeStartTime = currentTime < competitionData.details.startTime;
  const isComplete = ((_competitionData$deta = competitionData.details) === null || _competitionData$deta === void 0 ? void 0 : _competitionData$deta.state) === competitionBackendState.COMPETITION_COMPLETE;
  if (isPastRegistration && (model.isLastOrPastLastDrawNumber() || isComplete)) {
    return FINISHED;
  } else if (isBeforeStartTime) {
    return UPCOMING;
  } else if (!canRegister) {
    if (draw.getDrawState() >= DrawState.Finalized) {
      return REG_CLOSED_DRAW_FINALIZED;
    } else if (draw.getDrawState() >= DrawState.Regclosed) {
      return REG_CLOSED_DRAW_LIVE;
    } else if (draw.getDrawState() >= DrawState.Opened) {
      return REG_CLOSED_DRAW_OPEN;
    } else if (draw.getDrawState() >= DrawState.Defined) {
      return REG_CLOSED_DRAW_DEFINED;
    }
  } else if (canRegister) {
    if (draw.getDrawState() >= DrawState.Finalized) {
      return REG_OPEN_DRAW_FINALIZED;
    } else if (draw.getDrawState() >= DrawState.Regclosed) {
      return REG_OPEN_DRAW_LIVE;
    } else if (draw.getDrawState() >= DrawState.Opened) {
      return REG_OPEN_DRAW_OPEN;
    } else if (draw.getDrawState() >= DrawState.Defined) {
      return REG_OPEN_DRAW_DEFINED;
    }
    return REG_OPEN_DRAW_OPEN;
  }
  return NO_COMPETITION; 
};

let instance;

const createCompetitionModel = (data, draw) => {
  let model = data === null || data === void 0 ? void 0 : data.model;
  let timestamp = resolveTimeZone((data === null || data === void 0 ? void 0 : data.timestamp) || Date.now());
  let _currentDrawNumber;

  const setData = data => {
    timestamp = resolveTimeZone(Date.now());
    model = normalizeCompetition(data);
  };

  const getData = () => model;

  const getSnapshot = () => {
    const newModel = _objectSpread(_objectSpread({}, model), {}, {
      details: _objectSpread(_objectSpread({}, model.details), {}, {
        currentDrawNumber: getCurrentDrawNumber()
      })
    });
    return JSON.parse(JSON.stringify(newModel));
  };

  const getProductId = () => model.details.productId;
  const getCompType = () => model.compType;
  const getCurrentDrawNumber = () => {
    if (_currentDrawNumber && model.details.currentDrawNumber < _currentDrawNumber) {
      return _currentDrawNumber;
    }
    return model.details.currentDrawNumber;
  };
  const getCompetitionType = () => {
    var _model;
    return (_model = model) === null || _model === void 0 ? void 0 : _model.compType;
  };

  const getCompetitionId = () => model.id;

  const getLastDrawNumber = () => {
    if (model) {
      return model.details.drawNumberList[model.details.drawNumberList.length - 1];
    }
    return 0;
  };
  const getFirstDrawNumber = () => {
    if (model) {
      return model.details.drawNumberList[0];
    }
    return 0;
  };

  const getTimestamp = () => timestamp;

  const updateCurrentDrawNumber = () => {
    var _drawNumberList;
    const currentDrawNumber = getCurrentDrawNumber();
    const drawNumberList = model.details.drawNumberList;
    const index = drawNumberList.findIndex(did => did === currentDrawNumber);
    const nextDrawNumber = (_drawNumberList = drawNumberList[index + 1]) !== null && _drawNumberList !== void 0 ? _drawNumberList : currentDrawNumber;
    _currentDrawNumber = nextDrawNumber;
    logger.info("Updating currentDrawNumber on id: ".concat(getCompetitionId(), ", current: ").concat(currentDrawNumber, ", next: ").concat(nextDrawNumber));
  };

  const isLastDrawNumber = () => {
    const currentDrawNumber = getCurrentDrawNumber();
    const lastDrawNumber = model.details.drawNumberList.slice(-1).pop();
    return currentDrawNumber >= lastDrawNumber;
  };
  const isLastOrPastLastDrawNumber = () => {
    const currentDrawNumber = getCurrentDrawNumber();
    const lastDrawNumber = model.details.drawNumberList.slice(-1).pop();
    return Boolean(currentDrawNumber >= lastDrawNumber);
  };

  const updateCompetitionStatus = draw => {
    if (model && draw) {
      const lastStatus = model.status;
      model.status = resolveDrawStatus(draw, instance);
      if (lastStatus !== model.status) {
        logger.info("Updated competition status, prev status: ".concat(lastStatus, ", new status: ").concat(model.status));
      }
    }
  };

  const getStatus = () => {
    var _model2;
    return (_model2 = model) === null || _model2 === void 0 ? void 0 : _model2.status;
  };

  const isFinished = () => {
    var _model3;
    return ((_model3 = model) === null || _model3 === void 0 ? void 0 : _model3.status) === FINISHED;
  };
  const toJSON = () => ({
    model: getData(),
    timestamp: getTimestamp()
  });
  instance = {
    get _symbol() {
      return competitionSymbol;
    },
    setData,
    getData,
    getSnapshot,
    getProductId,
    getCompType,
    getCurrentDrawNumber,
    getCompetitionType,
    getCompetitionId,
    getFirstDrawNumber,
    getLastDrawNumber,
    getTimestamp,
    updateCurrentDrawNumber,
    isLastDrawNumber,
    isLastOrPastLastDrawNumber,
    updateCompetitionStatus,
    getStatus,
    isFinished,
    toJSON
  };
  if (model && draw) {
    updateCompetitionStatus(draw);
  }
  return instance;
};
const toExport = {
  createCompetitionModel,
  isCompetitionModel,
  resolveDrawStatus
};
if (svs.isServer) {
  module.exports = toExport;
} else {
  setGlobal('svs.components.marketplaceCompetition.competitionHandler.common', toExport);
}

 })(window);